import React from 'react';

import {
  LinkItem,
  TextItem,
  Divider,
  ArrowIcon,
  BackLink,
  MobileOnlyBackLink,
  InnerList,
  InnerListItem,
} from './BreadcrumbsV2.styles';

export type BreadcrumbV2LinkItemType = {
  to: string;
  label: string;
};

export type BreadcrumbsV2PropsType = {
  /** Array of BreadcrumbLinkItemTypes to be displayed with succeeding divider */
  linkItems: BreadcrumbV2LinkItemType[];
  /** Label for current selection  */
  disableBackLink?: boolean;
  currentSelectionLabel?: string;
  className?: string;
};

const BreadcrumbsV2: React.FC<BreadcrumbsV2PropsType> = ({
  linkItems,
  currentSelectionLabel,
  className,
  disableBackLink = false,
}) => {
  // Render nothing if no links are present.
  if (!linkItems || !linkItems.length) {
    return null;
  }

  // If there is only a single level above and no current selection, show only a back button.
  if (linkItems.length === 1 && !disableBackLink && !currentSelectionLabel) {
    return (
      <nav className={className} aria-label="breadcrumbs" data-testid="BreadcrumbsV2">
        <BackLink href={linkItems[0].to}>
          <ArrowIcon direction="left" height={16} width={16} />
          Back
        </BackLink>
      </nav>
    );
  }

  // Otherwise, show the entire breadcrumb path.
  const validLinks = linkItems.filter((item) => !!item.to);
  const previousLink = validLinks[validLinks.length - 1];
  return (
    <nav className={className} aria-label="breadcrumbs" data-testid="BreadcrumbsV2">
      <InnerList>
        {linkItems.map((item, index) => {
          const isLastItem = index === linkItems.length - 1;
          return (
            <InnerListItem key={`breadcrumb-${index}`}>
              {item.to ? (
                <LinkItem href={item.to} disableBackLink={disableBackLink}>
                  {item.label}
                </LinkItem>
              ) : (
                <TextItem disableBackLink={disableBackLink}>{item.label}</TextItem>
              )}
              {(!isLastItem || currentSelectionLabel) && (
                <Divider disableBackLink={disableBackLink}>/</Divider>
              )}
            </InnerListItem>
          );
        })}
        {currentSelectionLabel && (
          <InnerListItem>
            <TextItem disableBackLink={disableBackLink}>{currentSelectionLabel}</TextItem>
          </InnerListItem>
        )}
        {!!previousLink && !disableBackLink && (
          <InnerListItem>
            <MobileOnlyBackLink href={previousLink.to}>
              <ArrowIcon direction="left" height={16} width={16} />
              {previousLink.label}
            </MobileOnlyBackLink>
          </InnerListItem>
        )}
      </InnerList>
    </nav>
  );
};

export default BreadcrumbsV2;
